/**
 * Created by AlexanderC on 2/22/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let AbstractContext = exports.AbstractContext = function () {
  /**
   * @param {*} context
   */
  function AbstractContext() {
    let context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AbstractContext);

    this._context = {};

    this.addObj(context);
  }

  /**
   * @param {Kernel|*} kernel
   */


  _createClass(AbstractContext, [{
    key: 'addObj',


    /**
     * @param {*} obj
     *
     * @returns {AbstractContext|*}
     */
    value: function addObj(obj) {
      this._context = Object.assign(this._context, obj);

      return this;
    }

    /**
     * @param {String} key
     * @param {*} value
     *
     * @returns {AbstractContext|*}
     */

  }, {
    key: 'add',
    value: function add(key, value) {
      this._context[key] = value;

      return this;
    }

    /**
     * @returns {*}
     */

  }, {
    key: 'get',
    value: function get() {
      return this._context;
    }

    /**
     * @param {*} originalContext
     *
     * @returns {*}
     */

  }, {
    key: 'enrichEventContext',
    value: function enrichEventContext(originalContext) {
      originalContext = this.extend(originalContext);
      originalContext.timestamp = Date.now();

      return originalContext;
    }

    /**
     * @param {*} context
     *
     * @returns {*}
     */

  }, {
    key: 'extend',
    value: function extend(context) {
      return Object.assign({}, this.get(), context);
    }
  }], [{
    key: 'fromKernel',
    value: function fromKernel(kernel) {
      throw new Error('Context.fromKernel() not implemented!');
    }
  }]);

  return AbstractContext;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Context/AbstractContext.js
// module id = 380
// module chunks = 0